import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Testimonials } from './components/Testimonials';
import { ProblemSection } from './components/ProblemSection';
import { MethodSection } from './components/MethodSection';
import { ResultsSection } from './components/ResultsSection';
import { TomosSection } from './components/TomosSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { ComparisonTable } from './components/ComparisonTable';
import { MoreTestimonials } from './components/MoreTestimonials';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const PIXEL_ID = '1668014427688483';
export function App() {
  useEffect(() => {
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const first = document.getElementsByTagName('script')[0];
    first?.parentNode?.insertBefore(script, first);
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen w-full bg-canvas font-sans text-ink selection:bg-accent-soft" data-id="element-0" data-mp="3dlw4q1bpjt6b">
      <noscript data-id="element-1" data-mp="nuhhkgf627t8">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="nv0ypuwzss67" />
      </noscript>

      <Hero data-id="element-3" data-mp="38kvegdtbvi3" />
      <main data-id="element-4" data-mp="38b2ol1dva8p">
        <SocialProof data-id="element-5" data-mp="3ud1ftael3qb5" />
        <Testimonials data-id="element-6" data-mp="3udkr489qbgg7" />
        <ProblemSection data-id="element-7" data-mp="3uc9k7zkzlskv" />
        <MethodSection data-id="element-8" data-mp="3uf5ixq4nslad" />
        <ResultsSection data-id="element-9" data-mp="d4e57s05daw6" />
        <TomosSection data-id="element-10" data-mp="d3mkjc838xko" />
        <BonusesSection data-id="element-11" data-mp="d45vg8zbmlp7" />
        <PricingSection data-id="element-12" data-mp="d2bh5dik1ru3" />
        <ComparisonTable data-id="element-13" data-mp="851l3f0nuhxa" />
        <MoreTestimonials data-id="element-14" data-mp="86w6svjrae2f" />
        <GuaranteeSection data-id="element-15" data-mp="86cqfj9r7xqi" />
        <FAQSection data-id="element-16" data-mp="3gleaym6kt9gr" />
        <CostOfInaction data-id="element-17" data-mp="3gkla21uate6j" />
        <FinalCTA data-id="element-18" data-mp="3gm61hilbgh06" />
      </main>
      <Footer data-id="element-19" data-mp="3gj1t090tiz3p" />
    </div>;
}